import React, { Component } from "react";

export default class LeaveCarryProcessStatusWarningDialog extends Component {
  render() {
    return (
      <div className="col-sm-12 mt20">
        <div
          className="bg-primary"
          style={{ padding: "10px", marginBottom: "40px", marginTop: "10px" }}
        >
          <p style={{ fontSize: "20px", fontWeight: "bold" }}>
            New Leave Applications Disabled
          </p>
        </div>
        <div style={{ paddingLeft: "20px", paddingRight: "20px" }}>
          <h2>Earned Leave Carry process has been initiated.</h2>
          <h3>
            You cannot submit a new leave application until it's finished.
          </h3>
        </div>
        <div style={{ height: "100px" }}></div>

        <div
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            marginTop: "50px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <button
            type="button"
            className={"btn btn-primary"}
            style={{
              width: "150px",
            }}
            onClick={this.props.hideDialog}
          >
            Close
          </button>
        </div>
      </div>
    );
  }
}
